import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=b2d84b7c&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d84b7c",
  null
  
)

component.options.__file = "ForgetPassword.vue"
export default component.exports